<template>
<div class="no-results-found" style="padding-top: 4rem">
    <img v-if="type=='my_loads'" src="@/assets/images/no-loads.png" alt="Freight Tiger" style="width: 70%;">
    <div v-if="type=='supply_list'" class="text-center">
        <b-icon icon="exclamation-circle-fill" variant="dark"></b-icon>
        <p class="no-results-title">{{ 'All vehicles are currently occupied.' }}</p>
        <p class="no-results-body">{{ 'Create a load to alert fleet owners on your route.' }}</p>
    </div>
</div>
</template>
<script>
export default {
  props: {
    route: String,
    type: String
  }
}
</script>
<style>
.no-results-found{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
}
.search-icon{
    margin-bottom: 5px;
    margin-top: 10px;
}
.no-results-title{
    font-weight: 500;
    font-size: 16px;
    line-height: 24px;
    letter-spacing: 0.15px;
    margin-top:10px;
}
.no-results-body{
    color: #707070;
    font-weight: 400;
    font-size: 14px;
    text-align: center;
    line-height: 20px;
    padding-left:30px;
    padding-right:30px;
}
</style>
